module.exports = __webpack_public_path__ + "media/images/anchor-5fcc6f31876e5bbea4584d2a6a2f9505.svg";